import React from "react";
import { ReactComponent as AdviserNumberOneIcon } from "../../assets/icons/Adviser-Number1.svg";
import { ReactComponent as AdviserNumberTwoIcon } from "../../assets/icons/Adviser-Number2.svg";
import { ReactComponent as AdviserNumberThreeIcon } from "../../assets/icons/Adviser-Number3.svg";
import { ReactComponent as AdviserNumberFourIcon } from "../../assets/icons/Adviser-Number4.svg";
import { fetchNoOfAdvisers } from "frontend/Utils/GetNoOfAdvisers";


/**
 * Asynchronously retrieves an array of adviser value objects, each containing an icon and descriptive text.
 * The third value dynamically includes the current number of individual advisers supported.
 *
 * @async
 * @function
 * @returns {Promise<Array<{icon: JSX.Element, text: string}>>} 
 *   A promise that resolves to an array of objects, each with an icon (JSX element) and a text description.
 */
export const getAdviserValues = async () => {
  const adviserCount = await fetchNoOfAdvisers();

  return [
    {
      icon: <AdviserNumberOneIcon />,
      text: "Experience - Supporting our advisers since 2006",
    },
    {
      icon: <AdviserNumberTwoIcon />,
      text: "Whole of market Mortgage & Protection advice",
    },
    {
      icon: <AdviserNumberThreeIcon />,
      text: `Currently supporting over ${adviserCount} individual advisers`,
    },
    {
      icon: <AdviserNumberFourIcon />,
      text: "Fully independent Financial Planning proposition",
    },
  ];
};
